/**
 * The signed-in member's experience profile for the current workspace, read
 * from the membership row on the server (never browser storage, so it follows
 * the person to any device). `null` until it is known.
 *
 * Shared by the two places a person can land on the home: `/` (HomeGate) and
 * `/prioritization/dashboard` (ContributorAwareDashboard).
 */
import { useEffect, useState } from 'react';
import { useUserStore } from '../../stores/prioritization/userStore';
import { useTenantStore } from '../../stores/prioritization/tenantStore';
import { fetchExperienceProfile, type ExperienceProfile } from '../../lib/experienceProfile';

export function useExperienceProfile(): ExperienceProfile | null {
  const userId = useUserStore((s) => s.userId);
  const currentWorkspaceId = useTenantStore((s) => s.currentWorkspaceId);
  const [profile, setProfile] = useState<ExperienceProfile | null>(null);

  useEffect(() => {
    if (!userId || userId === 'unknown' || !currentWorkspaceId) return;
    let cancelled = false;
    void fetchExperienceProfile(currentWorkspaceId, userId).then((p) => {
      if (!cancelled) setProfile(p);
    });
    return () => {
      cancelled = true;
    };
  }, [userId, currentWorkspaceId]);

  return profile;
}
